import { BREAKPOINTS } from '../utils/constants';

const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  const variantInputEls = document.querySelectorAll('[data-variant-input]');
  const productControlsEl = document.querySelector('[data-product-controls]');
  const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-btn]');
  const selectEls = stickyAtc.querySelectorAll('[data-product-sticky-atc-select]');
  const form = document.querySelector('[data-product-main] form');
  if (!form || !stickyAtcButton) return;

  const mainAtcButton = form.querySelector('button[type="submit"]');
  if (!mainAtcButton) return;

  const syncButtons = () => {
    for (const name of stickyAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.removeAttribute(name);
      }
    }
    for (const name of mainAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.setAttribute(name, mainAtcButton.getAttribute(name));
      }
    }
    stickyAtcButton.innerHTML = mainAtcButton.innerHTML;
  };

  const mainAtcBtnObserver = new MutationObserver(syncButtons);
  syncButtons();
  mainAtcBtnObserver.observe(mainAtcButton, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
  });

  // Controlls and functions for sticky ATC
  if (stickyAtc && productControlsEl) {
    const getBottom = el => el.getBoundingClientRect().top + window.scrollY + el.offsetHeight;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const containerBottom = getBottom(productControlsEl);
      if (scrollY >= containerBottom) {
        stickyAtc.classList.remove('hidden');
      } else {
        stickyAtc.classList.add('hidden');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  stickyAtcButton.addEventListener('click', () => {
    if (desktopMediaQuery.matches) {
      mainAtcButton.click();
    } else {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (!variantInputEls.length) return;

  const updateStickySelect = (variantInput) => {
    const isSelectedInput = variantInput.matches('select') || variantInput.checked === true;

    if (isSelectedInput) {
      selectEls.forEach(select => {
        if (select.name.includes(variantInput.name)) {
          select.value = variantInput.value;
        }
      });
    }
  };

  const updateStickyAtcVariant = (event) => {
    const target = event.target;
    variantInputEls.forEach((inputEl) => {
      if (inputEl.value === target.value && target.name.includes(inputEl.name)) {
        if (inputEl.matches('select')) {
          inputEl.value = target.value;
        } else {
          inputEl.checked = true;
        }
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  variantInputEls.forEach(inputEl => {
    updateStickySelect(inputEl);

    inputEl.addEventListener('change', () => {
      updateStickySelect(inputEl);
    });
  });
  selectEls.forEach(select => select.addEventListener('change', updateStickyAtcVariant));
};

export default initProductStickyAtc;
